import React from 'react';
import './App.css';
import Navbar from './components/navbar/Navbar';
import Hero from './components/hero/Hero';
import About from './components/about/About';
import Science from './components/science/Science';
import Pipeline from './components/pipeline/Pipeline';
import Team from './components/team/Team';
import Partners from './components/partners/Partners';
import Contact from './components/contact/Contact';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />

        <About />

        <Science />

        <Pipeline />

        <Team />

        <Partners />

        <Contact />
      </main>
      <footer className="site-footer">
        <p>© {new Date().getFullYear()} Styx Biotechnologies Inc. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
